export default __webpack_public_path__ + "static/logo-8f01d66a82220a296365ab53b2b7fafb.png";